import { useState, useRef } from 'react';

const useVoiceToText = () => {
  const [voiceInputText, setvoiceInputText] = useState('');
  const [isListening, setIsListening] = useState(false);

  const recognitionRef = useRef(null);

  const initRecognition = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      alert('Speech recognition is not supported in this browser.');
      return null;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US';
    recognition.interimResults = true;
    recognition.continuous = true;

    recognition.onresult = (event) => {
      let liveText = `${voiceInputText} `;
      for (let i = event.resultIndex; i < event.results.length; i += 1) {
        liveText += event.results[i][0].transcript;
      }
      setvoiceInputText(liveText);
    };

    recognition.onerror = (event) => {
      console.log('Speech recognition error:', event.error);
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    return recognition;
  };

  const startListening = () => {
    const recognition = initRecognition();
    if (recognition) {
      recognitionRef.current = recognition;
      recognition.start();
      setIsListening(true);
    }
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
      setIsListening(false);
    }
  };

  return {
    voiceInputText,
    setvoiceInputText,
    startListening,
    stopListening,
    isListening,
  };
};

export default useVoiceToText;
